import { IcoBuilding16, IcoIdCard16, type Icon, IcoSsnCard16, IcoUserCircle16 } from '@onefootprint/icons';
import type {
  ApiNodeDataCustomDocument,
  DocumentRequestConfig,
  DocumentRequestKind,
} from '@onefootprint/request-types/dashboard';
import type { TFunction } from 'i18next';
import type { NodeIconProps } from '../../components/node-icon';

const iconForKind: Record<DocumentRequestKind, Icon> = {
  custom: IcoIdCard16,
  proof_of_address: IcoBuilding16,
  proof_of_ssn: IcoSsnCard16,
  identity: IcoIdCard16,
  selfie: IcoUserCircle16,
};

export const getCustomDocumentIcon = (data: ApiNodeDataCustomDocument): NodeIconProps => {
  // Custom nodes are initialized with an empty document. All other node kinds are initialized with an explicit document
  const docKind = data.document?.kind ?? 'custom';
  return { Icon: iconForKind[docKind], color: 'info' };
};

export const getCustomDocumentSubtitle = (
  data: ApiNodeDataCustomDocument,
  t: TFunction<'playbook-builder'>,
): string => {
  const labelForKind: Record<Exclude<DocumentRequestKind, 'custom'>, string> = {
    proof_of_address: t($ => $.collectDocument.proofOfAddress),
    proof_of_ssn: t($ => $.collectDocument.proofOfSsn),
    identity: t($ => $.collectDocument.identityDocument),
    selfie: t($ => $.node.selfie.uppercase),
  };

  const getLabel = (config: DocumentRequestConfig | undefined) => {
    if (!config) return t($ => $.collectCustomData.untitled);
    if (config.kind === 'custom') return config.data.name;
    return labelForKind[config.kind];
  };

  return getLabel(data.document);
};
